@use '../../scss/global' as *;
@use 'themes';

// ================================================================ //
// -- Component Styles

:host {
  display: block;

  .fluid-empty-state-container {

    &.variant-default {
      background-color: var(--empty-state-container-background-default);
    }

    &.variant-atmospheric {
      background-color: var(--empty-state-container-background-atmospheric);
    }

    .empty-state-actions-container {
      margin-top: var(--empty-state-container-actions-margin);
    }

    .empty-state-title {
      &.with-icon {
        display: flex;
        align-items: center;

        .empty-state-title-icon {
          padding: 0 1em;
        }
      }
    }
  }
}
